export enum DeliveryOption {
  Delivery = 'delivery',
  Pickup = 'pickup',
}
